import { createSlice } from '@reduxjs/toolkit';
import { shippingMethodTypes } from '@/constants/types';
import {
  deleteSpecificOrder,
  fetchOrderList,
  fetchPastOrderList,
  fetchSpecificOrderList,
} from '../thunk/orders-thunk';

const initialState = {
  // order history
  isLoading: false,
  items: [],
  selectedOrder: null,
  total: 0,
  page: 1,
  nextPageUrl: null,
  limit: 12,
  filters: {},
  type: '',
  isInvalidOrder: false,
  isOpenCancelRequestModal: false,
  deleteStatus: '',
  hasPastOrder: false,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    resetOrdersForCache() {
      return initialState;
    },
    reset: (state) => {
      state.items = [];
      state.selectedOrder = null;
      state.page = 1;
      state.limit = 12;
      state.nextPageUrl = null;
      state.isLoading = false;
      state.error = null;
      state.type = '';
      state.isInvalidOrder = false;
      state.isOpenCancelRequestModal = false;
      state.deleteStatus = '';
      state.hasPastOrder = false;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 1;
      state.items = [];
      state.limit = 12;
      state.nextPageUrl = null;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
    setIsOpenCancelRequestModal: (state, action) => {
      state.isOpenCancelRequestModal = action.payload;
    },
    setHasPastOrder: (state, action) => {
      state.hasPastOrder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrderList.fulfilled, (state, action) => {
        const responseData = action.payload;
        if (!responseData) {
          state.items = [];
          state.page = 1;
          state.nextPageUrl = null;
          state.total = 0;
        } else {
          state.items = responseData?.items;
        }
        state.isLoading = false;
      })
      .addCase(fetchOrderList.rejected, (state, action) => {
        state.isLoading = false;
        state.nextPageUrl = null;
        state.error = action.payload;
      })
      // fetchSpecificOrderList
      .addCase(fetchSpecificOrderList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.isInvalidOrder = false;
        state.selectedOrder = null;
      })
      .addCase(fetchSpecificOrderList.fulfilled, (state, action) => {
        const responseData = action.payload;
        if (!responseData) {
          state.selectedOrder = null;
          state.page = 1;
          state.nextPageUrl = null;
          state.total = 0;
          state.isInvalidOrder = true;
        } else {
          state.selectedOrder = {
            ...responseData,
          };
          state.isInvalidOrder = false;
        }
        state.isLoading = false;
      })
      .addCase(fetchSpecificOrderList.rejected, (state, action) => {
        state.isLoading = false;
        state.nextPageUrl = null;
        state.error = action.payload;
        state.selectedOrder = null;
        state.isInvalidOrder = true;
      })
      // deleteSpecificOrder
      .addCase(deleteSpecificOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.isInvalidOrder = false;
      })
      .addCase(deleteSpecificOrder.fulfilled, (state, action) => {
        const responseData = action.payload;
        state.deleteStatus = responseData?.status;
        // state.isLoading = false;
      })
      .addCase(deleteSpecificOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.deleteStatus = 'error';
        state.error = action.payload;
      })
      // past order
      .addCase(fetchPastOrderList.pending, (state) => {
        state.isLoading = true;
        state.hasPastOrder = false;
      })
      .addCase(fetchPastOrderList.fulfilled, (state, action) => {
        state.isLoading = false;
        const responseData = action.payload;
        if (responseData?.items?.length > 0) {
          state.hasPastOrder = true;
        }
      })
      .addCase(fetchPastOrderList.rejected, (state, action) => {
        state.isLoading = false;
        state.hasPastOrder = false;
        state.error = action.payload;
      });
  },
});

export const {
  setType,
  updateFilters,
  setSelectedOrder,
  resetOrdersForCache,
  setIsOpenCancelRequestModal,
  setHasPastOrder,
} = ordersSlice.actions;

export default ordersSlice.reducer;
